/**
 * Normalizers for the managed-button enums (NavDirection / SubmitVariant).
 *
 * The two client-facing wires emit lowercase strings — Web.Api serves the Shared
 * contract models (EnumMember values "previous"/"next", "simple"/"extended") and
 * the Web.Host page presenter serializes with StringEnumConverter(CamelCase).
 * Two other historical representations exist and must never crash a renderer:
 *  - the Domain Newtonsoft preset writes the NUMERIC enum values (the internal
 *    representation — also how BSON stores them);
 *  - any non-canonical casing (StringEnumConverter with a different naming
 *    strategy writes PascalCase).
 * Unknown/null values fall back to the renderer default ('next' / 'simple').
 */
export type NavDirection = 'previous' | 'next';
export type SubmitVariant = 'simple' | 'extended';

export function normalizeNavDirection(value: unknown): NavDirection {
    if (typeof value === 'number') {
        return value === 1 ? 'previous' : 'next';
    }

    return typeof value === 'string' && value.toLowerCase() === 'previous' ? 'previous' : 'next';
}

export function normalizeSubmitVariant(value: unknown): SubmitVariant {
    if (typeof value === 'number') {
        return value === 1 ? 'extended' : 'simple';
    }

    return typeof value === 'string' && value.toLowerCase() === 'extended' ? 'extended' : 'simple';
}
